import { render, staticRenderFns } from "./StartupsSelector.vue?vue&type=template&id=035969e4&scoped=true&"
import script from "./StartupsSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsSelector.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035969e4",
  null
  
)

export default component.exports